import { Controller } from "react-hook-form";
import { LABELS } from "~/resources/Labels";
import { MESSAGES } from "~/resources/Message";
import { FormCloudEnvironment} from "~/models/Commons ";
import { SIMPLInput } from "../../components/commons/input/SIMPLInput";
import { SIMPLDialog } from "../../components/commons/dialog/SimplDialog";
import { SIMPLSelectDropdown } from "../../components/commons/input/SIMPLSelectDropdown";
import { SIMPLButtonCustomized } from "../../components/commons/button/SIMPLButtonCustumized";
import { UseFormCloudEnvironment } from "./UseFormCloudEnvironment";
import { useEffect, useState } from "react";
import { getProviders } from "~/Utils/Utils";

interface Prop {
  onCloseModal: () => void;
  editedItem: FormCloudEnvironment | null;
  setConfig: Function;
  title?: string;
  refetch: () => void;
}

export const AddCloudEnvironment = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  title,
}: Prop) => {
  const { handleSubmit, control, errors, submitForm,provider } = UseFormCloudEnvironment(
    onCloseModal,
    refetch,
    editedItem?.id!
  );

  const [cloudProviderList, setCloudProviderList] = useState<any[]>([]);
  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit(submitForm)(event);
    setConfig({
      key: "",
      direction: LABELS.ASC,
    });
  };
  const fetchProviderList = () => {
    setCloudProviderList(getProviders(provider));
  };
  useEffect(() => {
    fetchProviderList();
  }, [provider]);

  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={onCloseModal}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized label={LABELS.Submit} primary />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={editedItem ? LABELS.EditScript : title!}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
    >
      <div className="flex justify-center">
        <div className="w-[500px]">
          <div className="flex flex-col w-full gap-y-4">
            <SIMPLInput
              name="environmentName"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: LABELS.NameRequired,
                },
              }}
              label={LABELS.Name}
              placeholder={LABELS.Name}
              required
              id="environmentName"
              fontWeight="bold"
              errorLabel={errors.environmentName?.message}
            />

            <SIMPLInput
              name="environmentDescription"
              control={control}
              label={LABELS.Description}
              id="environmentDescription"
              fontWeight="bold"
              errorLabel={errors.environmentDescription?.message}
              placeholder={LABELS.Description}
            />

            <SIMPLInput
              name="datacenterName"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: LABELS.DataCenterRequired,
                },
              }}
              label={LABELS.DataCenterName}
              placeholder={LABELS.DataCenterName}
              required
              id="datacenterName"
              fontWeight="bold"
              errorLabel={errors.datacenterName?.message}
            />

            <SIMPLInput
              name="datacenterDescription"
              control={control}
              label={LABELS.DataCenterDescription}
              placeholder={LABELS.DataCenterDescription}
              id="datacenterDescription"
              fontWeight="bold"
              errorLabel={errors.datacenterDescription?.message}
            />

            <SIMPLInput
              name="location"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: LABELS.LocationRequired,
                },
              }}
              label={LABELS.Location}
              required
              id="location"
              fontWeight="bold"
              errorLabel={errors.location?.message}
              placeholder={LABELS.Location}
            />
            <SIMPLInput
              name="iac"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: LABELS.IacRequired,
                },
              }}
              label={LABELS.Iac}
              required
              id="iac"
              fontWeight="bold"
              errorLabel={errors.iac?.message}
              placeholder={LABELS.Iac}
            />
            {/* Cloud Provider dropdown */}
            <div className="h-auto">
              <Controller
                name="cloudProviderId"
                control={control}
                rules={{ required: MESSAGES.MessageCloudProviderRequired }}
                render={({ field }) => (
                  <SIMPLSelectDropdown
                    id="cloudProviderId"
                    label={LABELS.CloudProviderWithSpace}
                    options={cloudProviderList?.map((cloudProviderName) => ({
                      label: cloudProviderName?.cloudProviderName,
                      value: cloudProviderName?.id,
                    }))}
                    isRequired
                    value={field.value}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                    }}
                    hideErrorLabel
                    errorLabel={errors.cloudProviderId?.message as string}
                    placeholder={LABELS.CloudProviderWithSpace}
                  />
                )}
              />
            </div>

            <SIMPLInput
              name="authenticationConfig"
              type="textarea"
              rows={4}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: LABELS.AuthenticationconfigRequired,
                },
                validate: (value: string) => {
                  try {
                    JSON.parse(value);
                    return true;
                  } catch {
                    return LABELS.InvalidJsonFormat;
                  }
                },
              }}
              label={LABELS.AuthenConfig}
              required
              id="authentificationConfig"
              fontWeight="bold"
              errorLabel={errors.authenticationConfig?.message}
              placeholder={LABELS.EnterValidJsonFormat}
            />
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
